module.exports = __webpack_public_path__ + "img/season.be5030ca.webp";